function pick( keys, from, into = { } ) {
  keys.forEach( ( k ) => {
    if ( from[k] != null ) {
      // eslint-disable-next-line no-param-reassign
      into[k] = from[k]
    }
  } )
  return into
}
function encodeQ( options ) {
  if ( options ) {
    const s = objectToQueryString( options )
    return s.length > 0 ? `?${s}` : ''
  }
  return ''
}

// https://gist.github.com/dgs700/4677933
// modified later to use URLSearchParams
function objectToQueryString( a ) {
  const s = new URLSearchParams()
  const add = ( key, value ) => {
    // If value is a function, invoke it and return its value
    const v = typeof value === 'function' ? value() : ( value == null ? '' : value )
    s.append( key, v )
  }

  if ( a instanceof Array ) { 
    for ( let n = 0; n < a.length; n++ ) {
      add( n, a[n] )
    }
  } else if ( a != null ) {
    Object.keys( a ).forEach( ( prefix ) => { 
      buildParams( prefix, a[prefix], add )
    } )
  }
  const output = s.toString()
  return output
}

function buildParams( prefix, obj, add ) {
  let i, l
  const rbracket = /\[\]$/
  if ( obj instanceof Array ) {
    for ( i = 0, l = obj.length; i < l; i++ ) {
      if ( rbracket.test( prefix ) ) {
        add( prefix, obj[i] )
      } else {
        buildParams( `${prefix}[${typeof obj[i] === 'object' ? i : ''}]`, obj[i], add )
      }
    }
  } else if ( typeof obj === 'object' ) {
    // Serialize object item.
    if ( obj != null ) {
      Object.keys( obj ).forEach( ( name ) => { 
        buildParams( `${prefix}[${name}]`, obj[name], add ) 
      } )
    }
    
  } else {
    // Serialize scalar item.
    add( prefix, obj )
  }
}

function getPatchOpsArray( patchOps ) {
  let arr = patchOps

  if ( arr && !Array.isArray( arr ) ) {
    // assume replace of each key
    arr = []
    Object.keys( patchOps ).forEach( ( key ) => {
      if ( patchOps[key] == null ) {
        arr.push( { op : 'remove', path : key } )  
      } else {
        arr.push( { op : 'replace', path : key, value : patchOps[key] } )  
      }
    } )
  }
  return arr
}

function combinePath( path, subpath ) {
  let p = path
  if ( subpath ) {
    // const sHasSlash = subpath[0] === '/'
    // const pHasSlash = path !== '' && !path.endsWith( '/' )
    
    const needsSlash = path !== '' && !path.endsWith( '/' ) && subpath[0] !== '/'
    if ( needsSlash ) {
      p += '/' 
    }
    p += subpath
  }
  return p
}

function getId( id, throwIfNull = true ) {
  // const oid = id
  const cid = id != null && typeof id === 'object' ? id.id : id
  if ( cid == null && throwIfNull ) {
    // eslint-disable-next-line no-throw-literal
    throw { status : 400, message : 'id is null' }
  }
  return cid
}

function getLastInPath( path ) {
  if ( path == null ) {
    return null
  }
  const idx = path.lastIndexOf( '/' )
  if ( idx < 0 ) {
    return null
  }
  return path.substring( idx + 1 )
}

export {
  encodeQ,
  objectToQueryString,
  getPatchOpsArray,
  combinePath, 
  getId,
  getLastInPath,
  pick
}
